import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import {
    ArrowUpRight,
    CheckCircle2,
    Mail,
    MapPin,
    MessageSquareText,
    Phone,
    Send,
} from 'lucide-react'


const Contact = () => {
    const [loading, setLoading] = useState(false)
    const [submittedName, setSubmittedName] = useState(null)
    const [errorMessage, setErrorMessage] = useState('')

    const handleSubmit = (e) => {
        e.preventDefault()
        setLoading(true)
        setErrorMessage('')

        const data = {
            id: 0,
            fullName: e.target.fullName.value.trim(),
            email: e.target.email.value.trim(),
            mobileNumber: e.target.mobileNumber.value.trim(),
            whatsappNumber: e.target.whatsappNumber.value.trim(),
            companyName: e.target.companyName.value.trim(),
        }

        fetch('https://api.kanchaneshver.com/api/EnquiryMaster/AddEnquiryMaster', {
            method: 'POST',
            headers: {
                Accept: '*/*',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(data),
        })
            .then((res) => res.json())
            .then((result) => {
                if (result.success) {
                    setSubmittedName(data.fullName.split(' ')[0])
                    e.target.reset()
                } else {
                    setErrorMessage(result.message || 'Something went wrong. Please try again.')
                }
            })
            .catch((err) => {
                setErrorMessage('Unable to submit right now. Please check your connection and try again.')
                console.log(err)
            })
            .finally(() => setLoading(false))
    }

    const inputClass =
        'h-[3.35rem] w-full rounded-2xl border border-slate-200 bg-[#f8fbff] px-4 font-semibold text-[#1f2633] outline-none transition focus:border-[#094D92] focus:bg-white focus:shadow-[0_12px_28px_rgba(9,77,146,0.08)]'

    return (
        <main className="min-h-screen bg-[linear-gradient(135deg,#f4f9ff_0%,#ffffff_48%,#fff7f9_100%)] pt-24 pb-16">
            {submittedName !== null && (
                <div
                    className="fixed inset-0 z-[1000] flex items-center justify-center bg-[#1f2633]/45 px-4 backdrop-blur-sm"
                    onClick={() => setSubmittedName(null)}
                >
                    <div
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="enquiry-success-title"
                        className="relative w-full max-w-md overflow-hidden rounded-[30px] border border-[#094D92]/10 bg-white px-6 pt-10 pb-7 text-center shadow-[0_30px_90px_rgba(9,77,146,0.25)] sm:px-8"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="absolute inset-x-0 top-0 h-1.5 bg-gradient-to-r from-[#094D92] via-[#eb427e] to-[#EDA60C]" />

                        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-gradient-to-br from-[#e8f7ee] to-[#d2f1de] shadow-[0_14px_34px_rgba(34,160,90,0.22)]">
                            <CheckCircle2 className="text-[#22a05a]" size={44} strokeWidth={2.4} />
                        </div>

                        <h2 id="enquiry-success-title" className="mt-6 text-2xl font-black text-[#202938]">
                            Thank you{submittedName ? `, ${submittedName}` : ''}!
                        </h2>
                        <p className="mt-3 text-sm font-semibold leading-7 text-slate-600">
                            Your loan enquiry has been submitted successfully. Our team will review your details and connect with you shortly on your mobile or WhatsApp.
                        </p>

                        <button
                            type="button"
                            autoFocus
                            onClick={() => setSubmittedName(null)}
                            className="mt-7 inline-flex w-full items-center justify-center rounded-full bg-gradient-to-r from-[#094D92] to-[#eb427e] px-8 py-3 font-black text-white shadow-[0_16px_35px_rgba(9,77,146,0.22)] transition hover:-translate-y-0.5"
                        >
                            Got it
                        </button>
                    </div>
                </div>
            )}



            <section className="container mx-auto mt-10 px-4 sm:px-8 xl:max-w-6xl xl:px-4">
    <div className="grid gap-6 lg:grid-cols-2 lg:items-stretch">
        <form onSubmit={handleSubmit} className="flex h-full flex-col rounded-[34px] border border-[#094D92]/10 bg-white p-6 shadow-[0_28px_80px_rgba(31,38,51,0.12)] sm:p-8 reveal-on-scroll contact-reveal-left">

       

            <div className="mt-7 grid gap-4 md:grid-cols-2">
                <input className={`${inputClass} md:col-span-2`} type="text" id="fullName" name="fullName" placeholder="Full Name" aria-label="Full Name" required />
                <input className={inputClass} type="email" id="email" name="email" placeholder="Email ID" aria-label="Email ID" required />
                <input className={inputClass} type="tel" id="mobileNumber" name="mobileNumber" placeholder="Mobile Number" aria-label="Mobile Number" inputMode="numeric" pattern="[0-9]{10}" maxLength={10} title="Enter a 10-digit mobile number" required />
                <input className={inputClass} type="tel" id="whatsappNumber" name="whatsappNumber" placeholder="WhatsApp Number" aria-label="WhatsApp Number" inputMode="numeric" pattern="[0-9]{10}" maxLength={10} title="Enter a 10-digit WhatsApp number" required />
                <input className={inputClass} type="text" id="companyName" name="companyName" placeholder="Company / Organisation / Employer Name" aria-label="Company / Organisation / Employer Name" required />
            </div>

            <div className="mt-8 flex flex-col items-center gap-3">
                {errorMessage && (
                    <p role="alert" className="w-full rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-center text-sm font-semibold text-red-600">
                        {errorMessage}
                    </p>
                )}
                <button
                    type="submit"
                    className={`inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-[#094D92] to-[#eb427e] px-8 py-3 font-black text-white shadow-[0_16px_35px_rgba(9,77,146,0.22)] transition hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:opacity-60 ${loading ? 'opacity-60 cursor-not-allowed' : ''}`}
                    disabled={loading}
                >
                    <Send size={17} />
                    {loading ? 'Applying...' : 'Apply Now Loans'}
                </button>
                <p className="text-center text-xs font-semibold text-slate-500">
                    By submitting, you agree to our privacy policy.
                </p>
            </div>
        </form>

       <div className="flex h-full flex-col rounded-[34px] border border-[#094D92]/10 bg-white p-6 shadow-[0_28px_80px_rgba(31,38,51,0.12)] sm:p-8 reveal-on-scroll contact-reveal-right">

            <p className="text-xs font-black uppercase tracking-wide text-[#eb427e]">Office Location</p>
            <h2 className="mt-2 text-3xl font-black text-[#202938]">Find us on the map</h2>
            <p className="mt-3 text-sm font-semibold leading-7 text-slate-600">
                Visit our office or connect with our support team for platform, onboarding, and service assistance.
            </p>

            <div className="mt-7 flex-1 overflow-hidden rounded-[26px] border border-slate-200">
                <iframe
                    title="KSDPL office location"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3668.3639082706377!2d75.78428917603206!3d23.15691471130017!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3963758f3817a49b%3A0xdeee376fb6cd6f8e!2sC21%20Mall!5e0!3m2!1sen!2sin!4v1762866711944!5m2!1sen!2sin"
                    className="h-full min-h-[390px] w-full"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                />
            </div>
        </div>
    </div>

  <div className="mt-6 grid gap-4 md:grid-cols-3 contact-info-grid">

    <a
        href="tel:+9201963018"
       className="rounded-2xl border border-[#094D92]/10 bg-white p-5 shadow-[0_16px_40px_rgba(9,77,146,0.08)] transition hover:-translate-y-1 hover:shadow-[0_22px_55px_rgba(9,77,146,0.12)] reveal-on-scroll contact-reveal-card"

    >
        <Phone className="text-[#eb427e]" size={22} />
        <h3 className="mt-4 text-lg font-black text-[#202938]">Call Us</h3>
        <p className="mt-2 text-sm font-semibold leading-6 text-slate-600">
            Speak with our support team for platform, onboarding, and service assistance.
        </p>
        <p className="mt-4 text-base font-black text-[#094D92]">9201963018</p>
    </a>

    <a
        href="mailto:info@myrinbazaar.com"
      className="rounded-2xl border border-[#094D92]/10 bg-white p-5 shadow-[0_16px_40px_rgba(9,77,146,0.08)] transition hover:-translate-y-1 hover:shadow-[0_22px_55px_rgba(9,77,146,0.12)] reveal-on-scroll contact-reveal-card"

    >
        <Mail className="text-[#eb427e]" size={22} />
        <h3 className="mt-4 text-lg font-black text-[#202938]">Email Us</h3>
        <p className="mt-2 text-sm font-semibold leading-6 text-slate-600">
            Send your enquiry, support request, or service-related questions to our team.
        </p>
        <p className="mt-4 break-all text-base font-black text-[#094D92]">info@myrinbazaar.com</p>
    </a>

    <a
        href="https://maps.app.goo.gl/RqDMHkJz3kCu9ku98"
        target="_blank"
        rel="noreferrer"
       className="rounded-2xl border border-[#094D92]/10 bg-white p-5 shadow-[0_16px_40px_rgba(9,77,146,0.08)] transition hover:-translate-y-1 hover:shadow-[0_22px_55px_rgba(9,77,146,0.12)] reveal-on-scroll contact-reveal-card"

    >
        <MapPin className="text-[#eb427e]" size={22} />
        <h3 className="mt-4 text-lg font-black text-[#202938]">Office</h3>
        <p className="mt-2 text-sm font-semibold leading-6 text-slate-600">
            Visit our office or open the location directly in Google Maps.
        </p>
        <p className="mt-4 text-sm font-black leading-6 text-[#094D92]">
            Office No. 109, 110, C21 Mall, Nanakheda Bus Stand, Ujjain, Madhya Pradesh - 456010
        </p>
    </a>
</div>

</section>
        <section className="container mx-auto px-4 sm:px-8 xl:max-w-6xl xl:px-4">
               <div className="relative overflow-hidden rounded-[34px] border border-[#094D92]/10 bg-white px-6 py-10 text-center shadow-[0_30px_90px_rgba(9,77,146,0.12)] sm:px-10 reveal-on-scroll contact-reveal-hero">

                    <div className="absolute -left-20 top-8 h-56 w-56 rounded-full bg-[#094D92]/10 blur-3xl" />
                    <div className="absolute -right-20 bottom-4 h-60 w-60 rounded-full bg-[#eb427e]/10 blur-3xl" />

                    <div className="relative mx-auto max-w-3xl">
                        <p className="inline-flex items-center gap-2 rounded-full border border-[#094D92]/15 bg-[#f7fbff] px-4 py-2 text-xs font-black uppercase tracking-wide text-[#094D92]">
                            <MessageSquareText size={16} />
                            Contact KSDPL
                        </p>

                        <h1 className="mt-6 text-[2.1rem] font-black leading-[1.08] text-[#202938] sm:text-[2.8rem] lg:text-[3.2rem]">
                            <span className="block">Let’s connect and move</span>
                            <span className="block bg-gradient-to-r from-[#094D92] via-[#eb427e] to-[#EDA60C] bg-clip-text text-transparent">
                                your lending workflow forward
                            </span>
                        </h1>

                        <p className="mx-auto mt-5 max-w-2xl text-base leading-8 text-slate-600">
                            Reach out for platform support, onboarding, DSA and banker coordination, service queries, or feedback about your KSDPL experience.
                        </p>
                    </div>
                </div>
            </section>

           <section className="container mx-auto mt-8 px-4 sm:px-8 xl:max-w-6xl xl:px-4">
    <div className="relative overflow-visible rounded-[32px] border border-[#094D92]/10 bg-[linear-gradient(135deg,#ffffff_0%,#f7fbff_52%,#fff4f8_100%)] p-6 shadow-[0_28px_80px_rgba(9,77,146,0.14)] reveal-on-scroll contact-reveal-panel">
        <div className="absolute inset-x-8 top-0 h-1 rounded-full bg-gradient-to-r from-[#094D92] via-[#eb427e] to-[#EDA60C]" />

        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
            <div className="flex max-w-3xl gap-4">
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-[#094D92] text-white shadow-[0_16px_34px_rgba(9,77,146,0.24)]">
                    <MessageSquareText size={24} />
                </div>

                <div>
                    <p className="text-xs font-black uppercase tracking-wide text-[#eb427e]">Feedback Survey</p>
                    <h2 className="mt-2 text-3xl font-black leading-tight text-[#202938]">Help us improve</h2>
                    <p className="mt-2 max-w-2xl text-sm font-semibold leading-7 text-slate-600">
                        Share your experience with our platform, services, and support so our team can keep improving the lending workflow.
                    </p>

                    <div className="mt-4 flex flex-wrap gap-2">
                        <span className="rounded-full border border-[#094D92]/10 bg-white px-3 py-1 text-xs font-black text-[#094D92] shadow-sm">DSA Feedback</span>
                        <span className="rounded-full border border-[#eb427e]/10 bg-white px-3 py-1 text-xs font-black text-[#eb427e] shadow-sm">Banker Feedback</span>
                    </div>
                </div>
            </div>

            <div className="group relative w-full pb-3 md:w-auto">
                <button type="button" className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-[linear-gradient(135deg,#094D92_0%,#eb427e_58%,#EDA60C_100%)] px-7 py-3.5 font-black text-white shadow-[0_18px_40px_rgba(9,77,146,0.26)] transition duration-300 hover:-translate-y-1 hover:scale-[1.02] hover:shadow-[0_24px_55px_rgba(235,66,126,0.28)] focus:outline-none focus:ring-4 focus:ring-[#eb427e]/20 md:w-auto">
                    Share Feedback
                    <ArrowUpRight className="transition duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" size={18} />
                </button>

                <div className="invisible absolute right-0 top-[calc(100%-0.55rem)] z-20 grid min-w-72 translate-y-3 gap-2 rounded-[24px] border border-[#094D92]/10 bg-white/95 p-2 opacity-0 shadow-[0_28px_70px_rgba(31,38,51,0.2)] backdrop-blur transition duration-200 group-hover:visible group-hover:translate-y-0 group-hover:opacity-100 group-focus-within:visible group-focus-within:translate-y-0 group-focus-within:opacity-100">
                    <Link to="/feedback/dsa" className="flex items-center justify-between gap-4 rounded-[20px] border border-transparent bg-[#f3f8ff] px-4 py-3 text-sm font-black text-[#094D92] transition duration-200 hover:-translate-y-0.5 hover:border-[#094D92]/15 hover:bg-white hover:shadow-[0_16px_34px_rgba(9,77,146,0.14)]">

                        <span>
                            <span className="block">DSA Feedback</span>
                            <span className="mt-1 block text-xs font-bold text-slate-500">Share DSA experience</span>
                        </span>
                        <ArrowUpRight size={15} />
                    </Link>

                   <Link to="/feedback/banker" className="flex items-center justify-between gap-4 rounded-[20px] border border-transparent bg-[#fff4f8] px-4 py-3 text-sm font-black text-[#eb427e] transition duration-200 hover:-translate-y-0.5 hover:border-[#eb427e]/15 hover:bg-white hover:shadow-[0_16px_34px_rgba(235,66,126,0.14)]">

                        <span>
                            <span className="block">Banker Feedback</span>
                            <span className="mt-1 block text-xs font-bold text-slate-500">Share banker experience</span>
                        </span>
                        <ArrowUpRight size={15} />
                    </Link>
                </div>
            </div>
        </div>
    </div>
</section>
        </main>
    )
}

export default Contact